import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  CircularProgress,
  useToast
} from '@chakra-ui/react';
import { useState } from 'react';
import { apiBlog } from '../../../../services/api';
import { InputDragAndDrop } from '../../../../components/InputDragAndDrop';


export function UpdateBannerHome({ userBlog }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const toast = useToast({
    position: 'top-right',
  });

  async function updateBannerHome({ userBlog }) {
    if (!image) {

      return toast({
        title: 'Você precisa escolher uma imagem',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });

    }

    try {
      setIsLoading(true);

      const formData = new FormData();
      formData.append('banner', image);

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: `Bearer ${userBlog.token}`
        },
      };

      const response = await apiBlog.post('/updateBanner', formData, config);

      toast({
        title: 'Banner atualizado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      setImage(null);

      onClose();

    } catch (error) {
      console.log(error);
      toast({
        title: 'Erro ao atualizar o banner',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }

    setIsLoading(false);
  }

  async function handleUpdateBannerHome() {
    await updateBannerHome({ userBlog });
  }

  return (
    <>
      <Button onClick={onOpen}>Mudar o Banner da Home</Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Você está alterando o banner</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {!isLoading && (
              <>
                <p>Escolha a imagem que deseja colocar no banner da home</p>
                {/* <input
                      type='file'
                      onChange={(e) => setImage(e.target.files[0])}
                    /> */}
                <InputDragAndDrop setImage={setImage} image={image} />
              </>
            )}
            {isLoading && (
              <CircularProgress isIndeterminate />
            )}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              variant='ghost'
              onClick={handleUpdateBannerHome}
              disabled={isLoading}
            >
              Alterar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
